import { defineNuxtPlugin } from '#app';

export default defineNuxtPlugin(() => {
    return new Promise((resolve) => {
        const script = document.createElement('script');
        script.src = '/stringee.bundle.min.js';
        script.async = true;
        script.onload = () => {
            resolve({
                provide: {
                    stringeeSDK: (window as any).stringeeSDK
                }
            });
        };
        document.head.appendChild(script);
    });
});